module.exports = __webpack_public_path__ + "media/promo/promo/images/bgm-74482e43df3946711cfb984e54e6a456.jpg";